var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearchLOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5833 24.3333H25.8717L25.265 23.7483C27.3883 21.2783 28.6667 18.0717 28.6667 14.5833C28.6667 6.805 22.3617 0.5 14.5833 0.5C6.805 0.5 0.5 6.805 0.5 14.5833C0.5 22.3617 6.805 28.6667 14.5833 28.6667C18.0717 28.6667 21.2783 27.3883 23.7483 25.265L24.3333 25.8717V27.5833L35.1667 38.395L38.395 35.1667L27.5833 24.3333ZM14.5833 24.3333C9.18833 24.3333 4.83333 19.9783 4.83333 14.5833C4.83333 9.18833 9.18833 4.83333 14.5833 4.83333C19.9783 4.83333 24.3333 9.18833 24.3333 14.5833C24.3333 19.9783 19.9783 24.3333 14.5833 24.3333Z",
    fill: "#F25C3EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchLOrange);
export default __webpack_public_path__ + "static/media/icon-search-l-orange.6bdbe2e5443c2246c5e71246db6da8f5.svg";
export { ForwardRef as ReactComponent };